export default __webpack_public_path__ + "static/media/Funsquare.94fbde77.png";